// @ts-ignore
import { SUBJECTS_SLUGS } from '@yandex-int/k-common/constants';
import { SUBJECT_LIBRARY_TAB_SLUG, Team } from '@yandex-int/k-common/typings';
import { Plus as IconPlus } from 'education-icons';
import { Button, Link, SimpleText, Text } from 'platform-components';
import { getMe } from 'platform-components/src/components/user/selectors';
import { InjectedProps as WithRouterPathHOC, withRouterPath } from 'platform-components/hocs';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import ym from 'react-yandex-metrika';
import { Action, bindActionCreators, Dispatch } from 'redux';

import { getCurrentYearCourseId } from 'common.components/course/selectors';
import { teamBuilderActions } from 'common.components/team-builder/actions';
import { TEAM_BUILDER_ENTRY_STEPS } from 'common.components/team-builder/typings';
import * as userActions from 'common.components/user/actions';
import { getCurrentClass } from 'common.components/user/selectors';
import { GO_TO_INFORMATICS_BANNER_CLICKED } from 'common.components/user/user.constants';
import { REDIRECT_SOURCE } from 'store/course-container/typings';
import { getSearchStringCourseIdOrDefault } from 'utils/get-course';
import { YM_LOCATION } from 'utils/ym-constants';

//@ts-ignore
import CreateClassButton from '../create-class-button/create-class-button';

import { UnavailableSubject } from './__unavailable-subject/empty-state__unavailable-subject';
import * as actions from './actions';
import { AddLessonParams, EMPTY_STATE_ACTION } from './typings';

import './empty-state.scss';

interface DispatchProps {
    addLesson: (goalParams: AddLessonParams) => void;
    startTeamBuilder: typeof teamBuilderActions.start;
    setWizardVariables: typeof userActions.setWizardVariables;
}

interface OwnProps {
    action?: EMPTY_STATE_ACTION;
    locationForMetrika?: YM_LOCATION;
    textId: string;
    goalId?: string;
    unavailableSubjectHeaderId?: string;
}

interface StoreProps {
    courseId: number | null;
    team: Team | null;
}

interface HOCProps extends WithRouterPathHOC {}

interface ComponentProps extends DispatchProps, OwnProps, StoreProps, HOCProps {}

export class EmptyState extends React.Component<ComponentProps> {
    static contextTypes = {
        staticUrls: PropTypes.object.isRequired,
    };

    static defaultProps = {
        action: EMPTY_STATE_ACTION.ADD_LESSON,
    };
    context!: React.ContextType<React.Context<{ staticUrls: Record<string, string> }>>;

    addLesson = () => {
        const {
            addLesson,
            goalId,
            match: {
                params: { subject },
            },
            courseId,
        } = this.props;

        if (courseId) {
            addLesson({
                goalId: goalId || 'teacher_lesson_creation_empty_state_create',
                subject: subject.toString(),
                courseId,
            });
        }
    };

    addSubject = () => {
        const { locationForMetrika, startTeamBuilder } = this.props;

        startTeamBuilder({
            entryPoint: TEAM_BUILDER_ENTRY_STEPS.SUBJECTS,
        });

        ym('reachGoal', 'teacher_empty_state_chose_subject', { location: locationForMetrika });
    };

    goToCourseContainers = () => {
        const { getRouterPath, history, setWizardVariables } = this.props;
        const { staticUrls } = this.context;

        ym('reachGoal', 'teacher_look_program', { from: REDIRECT_SOURCE.JOURNAL });

        setWizardVariables({ [GO_TO_INFORMATICS_BANNER_CLICKED]: true });

        history.push(
            getRouterPath(staticUrls.labClassLibrarySubjectTab, { tabSlug: SUBJECT_LIBRARY_TAB_SLUG.CONTAINER }) +
                history.location.search
        );
    };

    isEmptySubject = () => {
        const {
            match: {
                params: { subject },
            },
        } = this.props;

        return subject === SUBJECTS_SLUGS.custom;
    };

    // eslint-disable-next-line complexity
    getActionButton = () => {
        const {
            action,
            getRouterPath,
            match: {
                params: { classId, subject },
            },
            history,
        } = this.props;
        const {
            staticUrls: { labLibrarySubject },
        } = this.context;
        const isCurrentSubjectCustom = subject === SUBJECTS_SLUGS.custom;

        switch (action) {
            case EMPTY_STATE_ACTION.ADD_LESSON:
                const librarySubjectPath = getRouterPath(labLibrarySubject, { subject, classId });

                return (
                    <div className="empty-state__controls">
                        {!isCurrentSubjectCustom && (
                            <Link
                                isRouter
                                mix="empty-state__control"
                                theme={Link.THEME.INHERIT}
                                to={`${librarySubjectPath}${history.location.search}`}
                            >
                                <Button className="empty-state__button" icon={<IconPlus />} onClick={this.addLesson}>
                                    <SimpleText id="emptyState.createLesson" />
                                </Button>
                            </Link>
                        )}
                    </div>
                );
            case EMPTY_STATE_ACTION.ADD_TEAM:
                return <CreateClassButton />;
            case EMPTY_STATE_ACTION.ADD_SUBJECT:
                return (
                    <div className="empty-state__controls">
                        <Button className="empty-state__control" onClick={this.addSubject}>
                            <SimpleText id="emptyState.addSubject" />
                        </Button>
                    </div>
                );
            case EMPTY_STATE_ACTION.GO_TO_COURSE_CONTAINER:
                return (
                    <div className="empty-state__controls">
                        <Button className="empty-state__control" onClick={this.goToCourseContainers}>
                            <SimpleText id="emptyState.goToInformatics" />
                        </Button>
                    </div>
                );
            default:
                return null;
        }
    };

    render() {
        const { textId, unavailableSubjectHeaderId } = this.props;

        if (this.isEmptySubject()) {
            return <UnavailableSubject headerTextId={unavailableSubjectHeaderId} />;
        }

        return (
            <div className="empty-state">
                <Text id={textId} size={Text.SIZE.XL} type={Text.TYPE.MARKDOWN} />
                {this.getActionButton()}
            </div>
        );
    }
}

const mapStateToProps = (storeState: any, ownProps: HOCProps): StoreProps => {
    const {
        match: {
            params: { classId },
        },
    } = ownProps;
    const me = getMe(storeState);
    const currentYearCourseId = getCurrentYearCourseId(storeState);
    const team = getCurrentClass(storeState, { classId });

    return {
        // специальный костыль для КМ-ов, чтобы они могли заходить в любые курсы по get-параметру
        courseId: me ? getSearchStringCourseIdOrDefault(me, currentYearCourseId) : null,
        team,
    };
};

const mapDispatchToProps = (dispatch: Dispatch<Action>): DispatchProps =>
    bindActionCreators(
        {
            addLesson: actions.addLesson,
            startTeamBuilder: teamBuilderActions.start,
            setWizardVariables: userActions.setWizardVariables,
        },
        dispatch
    );

const EmptyStateComponent = withRouterPath(connect(mapStateToProps, mapDispatchToProps)(EmptyState));

EmptyStateComponent.displayName = 'EmptyState';

export default EmptyStateComponent;

export { EMPTY_STATE_ACTION };
